window.addEventListener('DOMContentLoaded', (event) => {

    // get .has__tabs
    const has__tabs = document.querySelectorAll('.has__tabs');
    if(has__tabs){
        has__tabs.forEach(tab => {
            // get tab_content_1 and tab_content_2
            const tab_content_1 = tab.querySelector('.tab_content_1');
            const tab_content_2 = tab.querySelector('.tab_content_2');

            // get btn_tab
            const btn_tab = tab.querySelectorAll('.btn_tab');
            if(btn_tab){
                btn_tab.forEach(tab => {
                    // get btn_tab_1 and btn_tab_2
                    const btn_tab_1 = tab.querySelector('.btn_tab_1');
                    const btn_tab_2 = tab.querySelector('.btn_tab_2');

                    // add event listener to btn_tab_1
                    btn_tab_1.addEventListener('click', () => {
                        // remove active class from btn_tab_2
                        btn_tab_2.classList.remove('active');
                        // add active class to btn_tab_1
                        btn_tab_1.classList.add('active');
                        // show tab_content_1
                        tab_content_1.style.display = 'block';
                        // hide tab_content_2
                        tab_content_2.style.display = 'none';
                    });

                    // add event listener to btn_tab_2
                    btn_tab_2.addEventListener('click', () => {
                        // remove active class from btn_tab_1
                        btn_tab_1.classList.remove('active');
                        // add active class to btn_tab_2
                        btn_tab_2.classList.add('active');
                        // show tab_content_2
                        tab_content_2.style.display = 'block';
                        // hide tab_content_1
                        tab_content_1.style.display = 'none';
                    });
                });
            }
        });
    }

});